document.addEventListener("DOMContentLoaded", function () {
    var destEl = document.querySelector('.offers-search-destinations');
    var hotelEl = document.querySelector('.offers-search-hotels');

    if (destEl) destEl.addEventListener('change', function () {
        var val = destEl.value;
        var options = document.querySelectorAll('.offers-search-hotels option');
        if (val == '') {
            options.forEach(function(o){ o.classList.remove('hidden-item'); });
        } else {
            options.forEach(function(o){ o.classList.add('hidden-item'); });
            document.querySelectorAll('.offers-search-hotels option[data-hotel=""]').forEach(function(o){ o.classList.remove('hidden-item'); });
            document.querySelectorAll('.offers-search-hotels option[data-hotel="' + val + '"]');
            // show matching hotel options
            document.querySelectorAll('.offers-search-hotels option').forEach(function(o){ if (o.dataset.hotel == val) o.classList.remove('hidden-item'); });
            if (hotelEl) hotelEl.value = '';
        }
    });
});
